export default {
  userId: '',
  username: '',
  token: '',
  user: {},
  router: '',
  language: localStorage.getItem('language') || 'tr',
  i18n: {},
  validator: {},

  alertObject: {
    color: 'info',
    message: '',
    position: 'top',
  },

  pageLoadingStatus: false,

  tagList: [],
  feedItems: [],
  tagListLoading: false,

  filterGroupId: null,
  filterGroupIName: null,

  sendedNewComer: null,
  sendedBornTodayUsers: null,

  notificationItems: [],
  totalUnSeenNotification: 0,

  //Chat variables
  connection: null,
  unreadMessageCount: 0,
  chats: [],
  chatGroups: [],
  currentConversation: [],
  loadingEarlier: false,
  showLoadEarlier: false,
  lastSendMessage: {},
  lastMessageDate: '',
  connectionStatus: false,

  notificationItems: [],
  totalUnSeenNotification: 0,

  createDialogStatus: false,
  updateDialogItem: {},

  //Live Stream
  liveStreamStartInfoDialogShow: false,
  joinLiveStreamDialoStatus: false,
  getOnGoingBroadcastsId: null,

  liveStreamDialogStatus: false,

  //thanks detail
  thanksDetailDialogStatus: false,
  thanksDetailUserId: null,

  //Platform Store Control
  platformStoreStatus: false,

  //RemoteConfig
  videoViewsRate: 0.1,
};
